var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length > 0
    ? _c(
        "w-menu",
        {
          attrs: {
            "close-on-blur": "",
            "close-on-click": "",
            width: "auto",
            value: _vm.value,
            x: _vm.x,
            y: _vm.y,
            "auto-up": "",
          },
          on: {
            input: function ($event) {
              return _vm.onInput($event)
            },
          },
        },
        [
          _c(
            "w-select-item-list",
            { attrs: { "rounded-top": "", "rounded-bottom": "" } },
            _vm._l(_vm.items, function (item, i) {
              return _c(
                "w-select-item",
                {
                  key: i,
                  ref: "items",
                  refInFor: true,
                  on: {
                    click: function ($event) {
                      return _vm.onClick(item.value)
                    },
                  },
                },
                [
                  _c(
                    "w-row",
                    { staticClass: "row" },
                    [
                      _c("w-fa", { attrs: { icon: item.icon } }),
                      _vm._v(_vm._s(item.text)),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }